/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S3_P1Inputs */

const en_guide_large_json_files_s3_p1 = /** @type {(inputs: Guide_Large_Json_Files_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For files too large to load into memory, use streaming JSON parsers. These process the file token by token without building the entire tree in memory:`)
};

const ko_guide_large_json_files_s3_p1 = /** @type {(inputs: Guide_Large_Json_Files_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메모리에 로드하기에 너무 큰 파일의 경우, 스트리밍 JSON 파서를 사용하세요. 전체 트리를 메모리에 구축하지 않고 토큰 단위로 파일을 처리합니다:`)
};

const ja_guide_large_json_files_s3_p1 = /** @type {(inputs: Guide_Large_Json_Files_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモリに読み込めないほど大きなファイルの場合は、ストリーミングJSONパーサーを使用してください。これらはメモリにツリー全体を構築せずに、ファイルをトークンごとに処理します：`)
};

/**
* | output |
* | --- |
* | "For files too large to load into memory, use streaming JSON parsers. These process the file token by token without building the entire tree in memory:" |
*
* @param {Guide_Large_Json_Files_S3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s3_p1 = /** @type {((inputs?: Guide_Large_Json_Files_S3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s3_p1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s3_p1(inputs)
	return ja_guide_large_json_files_s3_p1(inputs)
});